import React, { MouseEventHandler, useEffect, useState } from "react";
import JobListing from "./JobListing";
import { Filter } from "./Filter";

interface Props {
  stateNames: readonly string[];
  onFilter: (stateName: Filter | undefined) => void;
  initialLocationSelected?: string;
  jobListings: readonly JobListing[];
}

export default function JobsLocationsList({
  stateNames,
  onFilter,
  initialLocationSelected,
  jobListings,
}: Props) {
  const [activeState, setActiveState] = useState<string>();
  const [allowRemote, setAllowRemote] = useState<boolean>();
  const workingLocationIdRemote = 2;

  const onClickFilter: MouseEventHandler<HTMLButtonElement> = (event) => {
    const { stateName, allowRemote } = event.currentTarget.dataset;
    const allowRemoteBool = Boolean(allowRemote);

    setActiveState(stateName);
    setAllowRemote(allowRemoteBool);

    if (!stateName && !allowRemoteBool) {
      onFilter(undefined);
    } else {
      onFilter({ allowRemote: allowRemoteBool, state: stateName });
    }
  };

  useEffect(() => {
    setActiveState(initialLocationSelected);
  }, [initialLocationSelected]);

  return (
    <ul className="careers-positions__locations locations">
      <li>
        <button
          type="button"
          className={
            activeState === undefined && !allowRemote
              ? "active"
              : "text-gray-700"
          }
          id="all-locations-filter-button"
          onClick={onClickFilter}
        >
          All Locations
        </button>
      </li>
      {jobListings?.some(
        (job) => job.workingLocationId === workingLocationIdRemote
      ) && (
        <li key="remote-location-filter">
          <button
            type="button"
            id="remote-filter-button"
            data-allow-remote
            onClick={onClickFilter}
            className={allowRemote ? "active" : "text-gray-700"}
          >
            Remote
          </button>
        </li>
      )}
      {stateNames.map((state) => (
        <li key={`${state.toLowerCase()}-location-filter`}>
          <button
            type="button"
            id={`${state.toLowerCase()}-filter-button`}
            data-state-name={state}
            onClick={onClickFilter}
            className={
              activeState?.toUpperCase() === state.toUpperCase()
                ? "active"
                : "text-gray-700"
            }
          >
            {state}
          </button>
        </li>
      ))}
    </ul>
  );
}
